import React, {Component} from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
// import FormLabel from '@material-ui/core/FormLabel';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import i18n from '../../i18n';

const styles = {
  root: {
    
  },
  group : {
    display : "flex",
    flexDirection  :"row"
  }
  
};
const GreenRadio = withStyles({
  root: {
    color: "#8bc541",
    '&$checked': {
      color: "#8bc541",
    },
  },
  checked: {},
})(props => <Radio color="default" {...props} />);
class EmailNotification extends Component {
  render(){
    const {classes , value ,handleChange,labelPlacement} = this.props
    
    return (
      <div style={{display : "flex", padding: "10px 0"}}>
        <div style={{display : "flex" , alignItems : "center",flex: "1", fontSize : "14px" ,marginRight :"20px"} }>{labelPlacement}</div>
        <FormControl className={classNames(classes.root)} component="fieldset">
            {/* 서버로 보낼때 true가 수신 거부 false가 수신 동의임. */}
            <RadioGroup className={classNames(classes.group)} >
            <FormControlLabel value={"true"} control={<GreenRadio name="email" checked={value === "true"}  onChange={handleChange}/>} label={i18n.t("global.yes")} />
            <FormControlLabel value={"false"} control={<GreenRadio name="email" checked={value === "false"}  onChange={handleChange}/>} label={i18n.t("global.no")} />
            </RadioGroup>
        </FormControl>
      </div>
    );
  } 
}

export default withStyles(styles)(EmailNotification);